import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Input } from 'next/components/ui';

const Wrapper = styled.form`
  display: flex;
  padding: 12px 16px 0;
  position: relative;

  ${Button} {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    width: 76px;
  }

  ${Input} {
    border-bottom-right-radius: 0;
    border-color: var(--text-tertiary);
    border-top-right-radius: 0;
    width: 100%;
  }
`;

const SpoofControl = ({ onSubmit, spoofing }) => {
  const [value, setValue] = useState('');

  const handleChange = event => {
    const { value: text } = event.target;

    if (text === '' || /^[\d\b]+$/.test(text)) {
      setValue(text);
    }
  };

  const handleSubmit = event => {
    event.preventDefault();
    onSubmit(value);
  };

  if (spoofing) {
    return null;
  }

  return (
    <Wrapper onSubmit={handleSubmit}>
      <Input
        type="text"
        placeholder="Account ID"
        value={value}
        onChange={handleChange}
      />
      <Button kind="primary" onClick={handleSubmit}>
        Spoof
      </Button>
    </Wrapper>
  );
};

SpoofControl.propTypes = {
  onSubmit: PropTypes.func,
  spoofing: PropTypes.bool,
};

export default SpoofControl;
